<template>
  <div class="w-full min-h-screen md:overflow-x-visible" :class="showSpinner ? 'opacity-25' : ''">
    <div class="flex flex-1 h-screen">
      <main class="flex-1 h-full min-w-0 px-4 pt-4 overflow-x-hidden overflow-y-auto sm:pt-12 2xl:pt-2 lg:px-16 2xl:px-60 lg:flex"><div class="hidden lg:block w-96"></div>
        <section aria-labelledby="primary-heading" class="flex flex-col flex-1 h-full min-w-0 overflow-x-visible pt-14 lg:pt-0 lg:order-last">
          <TransitionScreen>
            <template v-slot:header>
              <h1 class="px-4 mt-6 text-3xl text-darkBlue lg:mt-16">
                {{ $t('vendor.acknowledgment.header') }}
              </h1>
            </template>

            <template v-slot:content>
              <form>
                <div class="px-6 grid gap-4 mt-4 text-darkBlue">
                  <h2 class="text-base font-bold md:text-xl"> {{ $t('vendor.acknowledgment.list1.header') }} </h2>

                  <ul class="list-disc ml-6">
                    <li> {{ $t('vendor.acknowledgment.list1.item1') }} </li>
                    <li> {{ $t('vendor.acknowledgment.list1.item2') }} </li>
                    <li> {{ $t('vendor.acknowledgment.list1.item3') }} </li>
                  </ul>

                  <div class="flex items-center">
                    <input
                      v-model="form.acknowledgment1"
                      type="checkbox"
                      id="acknowledgment1"
                      class="sm:h-6 sm:w-6 h-4 w-4"
                    />
                    <label for="acknowledgment1" class="md:text-xl sm:px-4 px-2"> {{ $t('vendor.acknowledgment.list1.checkbox') }} </label>
                  </div>

                </div>
                <div class="px-6 grid gap-4 mt-4 text-darkBlue">
                  <h2 class="text-base font-bold md:text-xl"> {{ $t('vendor.acknowledgment.list2.header') }}  </h2>

                  <ul class="list-disc ml-6">
                    <li>
                      {{ $t('vendor.acknowledgment.list2.item1') }}
                      <ul class="list-disc ml-6 block">
                        <li> {{ $t('vendor.acknowledgment.list2.item1.sub1') }} </li>
                        <li> {{ $t('vendor.acknowledgment.list2.item1.sub2') }} </li>
                        <li> {{ $t('vendor.acknowledgment.list2.item1.sub3') }} </li>
                        <li> {{ $t('vendor.acknowledgment.list2.item1.sub4') }} </li>
                      </ul>
                    </li>
                    <li>{{ $t('vendor.acknowledgment.list2.item2') }}</li>
                  </ul>
                  <div class="flex items-center">
                    <input
                      v-model="form.acknowledgment2"
                      type="checkbox"
                      id="acknowledgment2"
                      class="sm:h-6 sm:w-6 h-4 w-4"
                    />
                    <label for="acknowledgment2" class="md:text-xl sm:px-4 px-2"> {{ $t('vendor.acknowledgment.list2.checkbox') }} </label>
                  </div>
                </div>
              </form>
            </template>

            <template v-slot:footer>
              <ContinueBackButtons @continue="proceedToNext" @back="returnToPrevious"></ContinueBackButtons>
            </template>
          </TransitionScreen>
        </section>
      </main>
      <AppSideNavMenu :participantDetails="participantDetails" :slide="slideName" :id="enrollmentId"/>
    </div>
  </div>
  <GenesysChat></GenesysChat>

  <!-- Spinner -->
  <div class="fixed flex justify-center my-3 text-gray-500 left-1/2 top-1/2" v-if="showSpinner">
    <svg class="h-8 mr-3 -ml-1 animate-spin w-7 text-gtBlue600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
    </svg>
  </div>
</template>

<script>
import { useEnrollmentStore } from "@/stores/enrollment";
import GenesysChat from "@/views/Shared/GenesysChat.vue";
import { mapActions, mapState } from 'pinia';
import enrollmentService from 'Services/backend/enrollments';
import TransitionScreen from 'Views/EnrollmentPresentation/StaticScreens/transition.vue';
import edpService from 'Views/Enrollments/EnrollmentDetails/service';
import ContinueBackButtons from 'Views/Shared/ContinueBackButtons.vue';
import { getEnrolleeInitials } from 'Utilities/helper';

export default {
  name: 'VendorAcknowledgmentSlide',

  components: {
    GenesysChat,
    TransitionScreen,
    ContinueBackButtons,
  },
  data() {
    return {
      // Required for next/back
      enrollmentId: '',
      enrolleeId: '',
      enrolleeType: '',

      // Nested components
      slideName: 'Vendor Acknowledgment',
      showSpinner: true,
      participantDetails: {
        firstName: '',
        lastName: '',
      },

      // Variables
      form: {
        acknowledgment1: false,
        acknowledgment2: false,
      },
    };
  },

  methods: {
    proceedToNext() {
      if (this.showSpinner) return;

      enrollmentService.updateEnrolleeDetails(this.enrolleeId, this.payload).then(
        (response) => {
          edpService.processEnrolleePresentationSavedResponse(response, this.$toast.bind(this));
          this.$router.push({ name: 'ParticipantWelcome4Slide', params: this.routeParams });
        },
        (error) => {
          edpService.processEnrolleePresentationSavedResponse(error, this.$toast.bind(this));
          console.error(error);
        },
      );
    },
    returnToPrevious() {
      if (this.showSpinner) return;
      this.$router.push({ name: 'ParticipantWelcome3Slide', params: this.routeParams });
    },
    
    getEnrolleeInitials,
    ...mapActions(useEnrollmentStore, ['loadEnrollees']),
  },
  computed: {
    routeParams() {
      return { enrollmentId: this.enrollmentId, enrolleeId: this.enrolleeId, enrolleeType: this.enrolleeType };
    },
    payload() {
      return {
        type: 'VENDOR',
        vendor: {
          step: 1,
          ...this.form
        },
      };
    },
    ...mapState(useEnrollmentStore, ['getEnrollees']),
  },
  watch: {
    getEnrollees(newEnrollees) {
      if (newEnrollees) {
        this.showSpinner = false;
        this.form.acknowledgment1 = newEnrollees.vendor?.vendorDetails?.acknowledgment1;
        this.form.acknowledgment2 = newEnrollees.vendor?.vendorDetails?.acknowledgment2;

        this.participantDetails = getEnrolleeInitials(newEnrollees, this.enrolleeType);
      }
    },
  },
  async created() {
    this.enrollmentId = this.$route.params.enrollmentId;
    this.enrolleeId = this.$route.params.enrolleeId;
    this.enrolleeType = this.$route.params.enrolleeType;
    await this.loadEnrollees(this.$route.params.enrolleeId);
  },
};
</script>

<style></style>
